// ===========================================================================
// Playground (Módulo DEV-ONLY) — Constantes.
//
// IMPORTANTE: Este módulo es EXCLUSIVO de desarrollo. NO debe existir en
// producción. El gating se hace contra `process.env.NODE_ENV`:
//   - `yarn start`  → NODE_ENV = "development"  → PLAYGROUND_ENABLED = true
//   - `yarn build`  → NODE_ENV = "production"   → PLAYGROUND_ENABLED = false
//
// Como CRA fuerza NODE_ENV en cada comando, no hay env var que alguien pueda
// togglear por error. En el bundle de producción las rutas y el ítem del
// sidebar ni siquiera se registran, y el dead-code-elimination de webpack
// remueve el módulo entero.
// ===========================================================================

export const PLAYGROUND_ENABLED = process.env.NODE_ENV === "development";

export const PLAYGROUND_BASE_PATH = "/playground";

export const PLAYGROUND_TABS = {
  ANALYZER: "analyzer",
  SANDBOX: "sandbox",
  GUIDE: "guide",
};

// Colores MUI por método HTTP (para chips en el analyzer + tester).
export const HTTP_METHOD_COLORS = {
  GET: "success",
  POST: "primary",
  PUT: "warning",
  PATCH: "secondary",
  DELETE: "error",
};
